// extracted by mini-css-extract-plugin
export default {"filters":"_nffKeqg","groupBy":"JHjMgFUO","totals":"sxmSpRVb","section":"AfDqKq__"};